const data =  {
    meta : {
        title       : "WASD Labs - Developer Software, Website dan Aplikasi Mobile Terbaik di Makassar",
        description : "WASDlabs adalah developer software desktop, website dan mobile android terbaik di Makassar. Berpengalaman dan siap memberikan solusi kebutuhan IT anda.",
        imageUrl    : "/images/preview.png",
        imageAlt    : "/images/preview.png"
    },
    banner : {
        id : [
            {
                title : "Solusi IT Dalam Satu Langkah",
                subTitle : "WASD Labs adalah developer software, website, aplikasi mobile, VR, AR, 3D Modeling, IoT,\n" +
                    "Jasa Drone dengan pengalaman lebih dari 5 tahun. Siap menyediakan solusi untuk rencana IT anda.",
                buttonText : "Konsultasi Kebutuhan Anda",
                buttonType : "call"
            }, {
                title : "Aktivitasi Digital Industri",
                subTitle : "WASD Labs membantu transformasi bisnis anda untuk meraih market yang lebih besar dengan digital, anda hanya perlu konsultasikan kebutuhan anda.",
                buttonText : "Hubungi Sekarang",
                buttonType : "call"
            }, {
                title : "World Class Quality App",
                subTitle : "WASD Labs menghadirkan kualitas aplikasi terbaik dengan semua kebutuhan digital anda, dimana setiap aplikasi telah melalui proses testing dan uji Quality Assurance.",
                buttonText : "Lihat Portoflio",
                buttonType : "link"
            }
        ]
    },
    about : {
        id : {
            title : "Kenapa Memilih Kami",
            subTitle : "WASD Labs, dengan pengalaman lebih dari 5 tahun, menyediakan layanan IT terlengkap dan terjangkau. Dengan \"Prototype-Approach\" kami memastikan\n" +
                "layanan yang kami sediakan sesuai dengan kebutuhan anda.",
            advantages : [
                {
                    img : "/images/about/team.svg",
                    title : "Dedicated Team",
                    description : "Tim terpercaya dan berdedikasi tinggi. Telah memenangkan berbagai kompetisi dalam negeri, salah satunya Wira Usaha Muda Mandiri 2017."
                },
                {
                    img : "/images/about/model.svg",
                    title : "Custom Made Software",
                    description : "Semua layanan dibuat khusus untuk memberikan solusi yang anda butuhkan. Karena tiap permasalahan membutuhkan solusi yang berbeda."
                },
                {
                    img : "/images/about/communication.svg",
                    title : "Fully Responsive",
                    description : "Kontak yang siap membantu anda kapan saja anda butuhkan, sekecil apapun masalah anda."
                },
                {
                    img : "/images/about/mid.svg",
                    title : "Any Kind, Any Time",
                    description : "Tim kami terdiri dari developer dengan kemampuan bervariasi dan up to date dengan teknologi terbaru saat ini."
                }
            ]
        }
    },
    videos : {
        id : {
            title : "Karena tiap kebutuhun memiliki solusi berbeda",
            subTitle  : "Kami mengerti bahwa solusi yang anda butuhkan tentunya berbeda dengan yang lain. Karenanya, setiap layanan kami tawarkan selalu disesuaikan dengan kebutuhan dan keinginan anda.",
            buttonText : "LIHAT VIDEO"
        }
    },
    service : {
       id : {
           title : "Layanan Kami",
           subTitle : "Kami menyediakan berbagai layanan yang dapat anda pilih sesuai kebutuhan Anda.",
           tag : [
               {
                   img : "/images/service/website.png",
                   title : "Website",
                   description : "Pembuatan web dilengkapi \n Hosting & Domain"
               }, {
                   img : "/images/service/smartcity.png",
                   title : "Smart City",
                   description : "Aplikasi terkoneksi\n" +
                       "antar Instansi"
               }, {
                   img : "/images/service/drone.png",
                   title : "Drone",
                   description : "Aerial Drone Sites &\n" +
                       "Road Traffic Survey Service"
               }, {
                   img : "/images/service/desktop.png",
                   title : "Desktop App",
                   description : "Pembuatan Aplikasi\n" +
                       "Retail, Penjualan, dll"
               }, {
                    img : "/images/service/ar.png",
                    title: "Augmented Reality",
                    description : "Jasa pembuatan Reality\n" +
                        "Interaktif untuk bisnis Anda"
               }, {
                   img : "/images/service/iot.png",
                   title: "Internet Of Things",
                   description : "Kecerdasan buatan, Interconnected devices"
               }, {
                   img : "/images/service/smartphone.png",
                   title: "Mobile App",
                   description : "Pembuatan Aplikasi\n" +
                       "Android, IOS, dll"
               }, {
                   img : "/images/service/vr.png",
                   title: "Virtual Reality",
                   description : "Jasa Tour Virtual foto & video 360"
               }, {
                   img : "/images/service/support.png",
                   title: "Jasa Konsultan IT",
                   description : "Konsultasi Data Analitik\n" +
                       "Digital Marketing Bisnis"
               }
           ]
       }
    },
    portofolio : {
        id : {
            title : "Portofolio",
            subTitle : "Hasil dari kerja keras kami, sebagai team yang telah dipercaya berbagai pihak.",
            buttonText : "Lihat Semua",
        }
    },
    client : {
        id : {
            title : "Client Kami",
            subTitle : "\"Customers may forget what you said but they'll never forget how you made them feel.\" Memenuhi kebutuhan IT anda adalah keahlian kami.",
        }
    },
    testimonial : {
        id : {
            title : "Apa Kata Mereka",
            subTitle : "Bukan kami yang mendefinisikan siapa kami sebenarnya, tetapi apa yang kami kerjakan yang mendefinisikan diri kami.",
        }
    },
    award : {
        id : {
            title : "Teruji & Terpercaya",
            subTitle : "Bukan kami yang mendefinisikan siapa kami sebenarnya, tetapi apa yang kami kerjakan yang mendefinisikan diri kami.",
        }
    },
}

export default data;